var _defs, _rect, _rect2, _path, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1a8044;\n      }\n\n      .cls-2 {\n        fill: #afbdc7;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #d6dee2;\n      }\n\n      .cls-5 {\n        fill: #1fb25b;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 10.73,
    width: 2.12,
    height: 2.88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 9.62,
    width: 17.88,
    height: 2.23,
    rx: 1.11,
    ry: 1.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,11.84h18.99c.55,0,1.01.45,1.01,1.01v6.15c0,.55-.45,1.01-1.01,1.01H1.01C.45,20,0,19.55,0,18.99v-7.15H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.88,0H3.12c-.55,0-1,.45-1,1v10.84h15.76v-7.84l-2.66-1.35-1.34-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.88,3c0,.55.45,1,1,1h3L13.88,0v3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.2,
    y: 6.67,
    width: 9.6,
    height: 0.72,
    rx: 0.36,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.2,
    y: 8.84,
    width: 9.6,
    height: 0.72,
    rx: 0.36,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.2,
    y: 4.51,
    width: 4.8,
    height: 0.72,
    rx: 0.36,
    ry: 0.36
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.71,15.92c0-1.48,1.13-2.54,2.66-2.54.85,0,1.55.31,2.02.87l-.73.67c-.33-.38-.74-.58-1.23-.58-.92,0-1.57.65-1.57,1.57s.65,1.57,1.57,1.57c.49,0,.9-.2,1.23-.58l.73.67c-.46.57-1.17.88-2.02.88-1.52,0-2.65-1.06-2.65-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.72,17.89l.39-.86c.41.3,1.03.51,1.62.51.67,0,.95-.23.95-.53,0-.92-2.85-.29-2.85-2.11,0-.83.67-1.53,2.07-1.53.62,0,1.25.15,1.7.43l-.35.86c-.46-.26-.92-.39-1.36-.39-.67,0-.93.25-.93.56,0,.9,2.85.28,2.85,2.08,0,.82-.68,1.52-2.08,1.52-.78,0-1.56-.23-2-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.29,13.47l-2.12,4.91h-1.12l-2.12-4.91h1.23l1.49,3.51,1.51-3.51h1.13Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.9ec82b993d6421815bd6c3a2b8599d5e.svg";
export { ForwardRef as ReactComponent };